import { useState, useEffect, useRef } from "react";
import dayjs from 'dayjs';

import { Button, Form, Spin, Card, Tabs, Row, Col, Input } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';

import { apiCand } from "../../../services/apiCand";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import "../style.css";

import { ICtrlDoc } from "../../../Interfaces/DadosPrevicInterfaces";
import { IOutroCargo, ITipoFuncao } from "../Componentes/InterfaceOutroCargo";
import Watermark from "../../../components/WaterMark";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";

import { maskCnpj, maskCpf } from "../../../utils/maskFunctions";
import { IErroApi, IAreaConhecimento } from "../../../Interfaces/Interfaces";
import OutroCargoPerfil from "../Componentes/OutroCargoPerfil";
import { useLocation } from "react-router";
import { hasText, isAntesDoTermino, isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { IAuditoria, IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import InfoHistorico from "../../../components/InfoHistorico";
import Auditoria from "../../../components/Auditoria";
import PessoaFisicaDadosPessoaisComplementares from "../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import { apiAuxiliar, getAreasConhecimento, getTiposFuncoes } from "../../../services/apiAuxiliar";


const Manter = (props: any) => {
  const [form] = Form.useForm();
  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);
  const handlerRef = useRef<(e: BeforeUnloadEvent) => void>(null);

  const [idPessoaFisica, setIdPessoaFisica] = useState(0);

  const [dadosOutroCargo, setDadosOutroCargo] = useState<IOutroCargo>();
  const [dadosAuditoria, setDadosAuditoria] = useState<IAuditoria[]>([]);
  const [registroHistorico, setRegistroHistorico] = useState<IAuditoria>();

  const [manter, setManter] = useState(2); // 2 : Detalhar / 3 : Alterar / 9 : Histórico
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [entidades, setEntidades] = useState<IEntidade[]>([]);
  const [areasConhecimento, setAreasConhecimento] = useState<IAreaConhecimento[]>([]);
  const [tiposFuncoes, setTiposFuncoes] = useState<ITipoFuncao[]>([]);

 
  useEffect(() => {
    const storedHistorico = sessionStorage.getItem("registroHistorico");
    if (storedHistorico) {
      sessionStorage.removeItem("registroHistorico"); // optional: avoids reuse on refresh
      setManter(9);
      let storedData = JSON.parse(storedHistorico);
      let obj = {
        ...JSON.parse(storedData.json.corpoPre),
        entidade: storedData.entidade
      };
      setDadosOutroCargoFull(obj);
      setRegistroHistorico(storedData.json);
      window.scrollTo(0, 0)
      mostrarInfo("Registro Histórico", "Você está agora em uma nova janela e vendo um registro histórico. Edições não estão disponíveis");
    } else if (isStateValid(state)) {
      setManter(state.manter)
      setDadosOutroCargoFull(state.data);
      // setIdPessoaFisica(state.data.pessoaFisica.idPessoaFisica);
      // form.setFieldsValue({
      //   "nuCpf": state.data.pessoaFisica.nuCpf ? state.data.pessoaFisica.nuCpf : state.nuCpf,
      //   "nmPessoaFisica": state.data.pessoaFisica.nmPessoaFisica ? state.data.pessoaFisica.nmPessoaFisica : state.nmPessoaFisica,
      // });
    }

    getAreasConhecimento(setAreasConhecimento, setLoading);
    getTiposFuncoes(setTiposFuncoes, setLoading);
    if (ctrlDoc.length === 0) getCtrlDocCons();

    // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
    handlerRef.current = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Still required in most browsers
    };

  }, []);

  useEffect(() => {

    // Verifica se existe registro histórico incompleto. Se sim, consulta o registro novamente para atualizar os dados históricos.
    // Verifica o primeiro e o último registro. Em teoria
    if (!registroHistorico && dadosAuditoria && dadosAuditoria.length > 0) {
      let size = dadosAuditoria.length;
      if (size > 0 && (
        //        (dadosAuditoria[size - 1].dtPos === undefined || dadosAuditoria[size - 1].dtPos === "")
        // || (dadosAuditoria[size - 1].eventos === undefined || dadosAuditoria[size - 1].eventos.length === 0)
        (dadosAuditoria[0].dtPos === undefined || dadosAuditoria[0].dtPos === "")
        || (dadosAuditoria[0].eventos === undefined || dadosAuditoria[0].eventos.length === 0)
      )){
        getOutroCargoPorId(dadosOutroCargo?.idOutroCargo);
      }
    }

  }, [dadosAuditoria]);

  useEffect(() => {
    if (manter === 2 && dadosOutroCargo) { // SE OS DADOS DE OUTRO CARGO JÁ ESTIVEREM PREENCHIDOS EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosOutroCargoFull(dadosOutroCargo);
    }

    if (manter === 3) {
      setIsDirty(true);
    } else setIsDirty(false);

  }, [manter]);

  useEffect(() => {
    if (registroHistorico && manter !== 9) { // AUDITORIA/HISTÓRICO
      // Save data in sessionStorage
      sessionStorage.setItem("registroHistorico", JSON.stringify({json: registroHistorico, entidade: dadosOutroCargo?.entidade}));
      // Open new tab
      window.open("/outro-cargo/manter", "_blank");
    }
  }, [registroHistorico]);


  // PARA USUÁRIOS ENTIDADE DESABILITA O BOTÃO EDITAR CASO situacaoVigencia === flase. EM TEORIA, SIGNIFICA QUE O REGISTRO CHEGOU AO SEU FIM E NÃO PODE MAIS SER ALTERADO.
  function desabilitaBtnEditar(title: string, msg: string) {
    if (isAntesDoTermino(dadosOutroCargo?.dtFimAtuacao)){
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.ENTIDADE_ALTERAR]))
        return false;
    }
    return !hasPermissao([Papel.DILIC_MASTER]);
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  const getOutroCargoPorId = async (idOutroCargo?: number) => {
    try {
      setTipLoading("Atualizando registros históricos");
      setLoading(true);

      let lQuery = `outroCargo/${idOutroCargo}`;
      const { data } = await apiCand.get(lQuery);
      setDadosOutroCargoFull(data);

    } catch (error) {
      // console.log(error);
      errorMessage("Erro ao atualizar os registros históricos");
    } finally {
      setLoading(false);
    }
  };


  function setDadosOutroCargoFull(outroCargo: IOutroCargo) {
    // console.log(outroCargo);
    form.setFieldsValue({
      "idOutroCargo": outroCargo.idOutroCargo,

      "nuCpf": maskCpf( outroCargo.pessoaFisica && outroCargo.pessoaFisica.nuCpf ? outroCargo.pessoaFisica.nuCpf : ""), // state.nuCpf,
      "nmPessoaFisica": outroCargo.pessoaFisica && outroCargo.pessoaFisica.nmPessoaFisica ? outroCargo.pessoaFisica.nmPessoaFisica : "", // state.nmPessoaFisica,

      "matriculaEfpc": outroCargo.entidade?.matricula ?? "",
      "sigla": outroCargo.entidade?.sigla ?? "",

      "idTipoFuncao": outroCargo.tipoFuncao.idTipoFuncao,
      "nmTipoFuncao": outroCargo.tipoFuncao.nmTipoFuncao,
      "idAreaConhecimento": outroCargo.areaConhecimento.idAreaConhecimento,
      "nmArea": outroCargo.areaConhecimento.nmArea,

      "dtInicioAtuacao": outroCargo.dtInicioAtuacao ? dayjs(outroCargo.dtInicioAtuacao) : undefined,
      "dtFimAtuacao": outroCargo.dtFimAtuacao ? dayjs(outroCargo.dtFimAtuacao) : undefined,
    });

    setIdPessoaFisica(outroCargo.pessoaFisica && outroCargo.pessoaFisica.idPessoaFisica ? outroCargo.pessoaFisica.idPessoaFisica : 0); //outroCargo.idPessoaFisica);

    if (outroCargo.pessoaJuridica && hasText(outroCargo.pessoaJuridica.cnpj)) {
      form.setFieldsValue({
        razaoSocial: outroCargo.pessoaJuridica.razaoSocial,
        nuCnpj: maskCnpj(outroCargo.pessoaJuridica.cnpj),
      });
    }

    setDadosAuditoria(outroCargo.auditoria);
    setDadosOutroCargo(outroCargo); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.

    //    console.log(outroCargo);

  }

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  //  const [desabilitarEditar, setDesabilitarEditar] = useState(false);

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json = {
      idOutroCargo: form?.getFieldValue("idOutroCargo"),
      idPessoaFisica: idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      idAreaConhecimento: form?.getFieldValue("idAreaConhecimento"),
      idTipoFuncao: form?.getFieldValue("idTipoFuncao"),
      cnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
      dtInicioAtuacao: form?.getFieldValue("dtInicioAtuacao") ? dayjs(form?.getFieldValue("dtInicioAtuacao")).format("YYYY-MM-DD") : "",
      dtFimAtuacao: form?.getFieldValue("dtFimAtuacao") ? dayjs(form?.getFieldValue("dtFimAtuacao")).format("YYYY-MM-DD") : "",
      statusReg: 1,
    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.put(`/outroCargo/${form?.getFieldValue("idOutroCargo")}`, json).then((response) => {
      setLoading(false);
      resetForm();
      successMessage(
        `Outro Cargo ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) atualizado com Sucesso`
      );

      setManter(2) // VOLTA AO ESTADO INICIAL

      form.setFieldsValue({
        "matriculaEfpc": response.data.entidade.matricula ? response.data.entidade.matricula : form?.getFieldValue("matriculaEfpc"),
        "sigla": response.data.entidade.sigla ? response.data.entidade.sigla : form?.getFieldValue("sigla"),
        "nuCpf": response.data.pessoaFisica.nuCpf ? response.data.pessoaFisica.nuCpf : form?.getFieldValue("nuCpf"),
        "nmPessoaFisica": response.data.pessoaFisica.nmPessoaFisica ? response.data.pessoaFisica.nmPessoaFisica : form?.getFieldValue("nmPessoaFisica"),
      });

      // setDadosOutroCargoFull(response.data);
      getOutroCargoPorId(response?.data.idOutroCargo);

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };


  const resetForm = () => {
    setLoading(true);

    form.setFieldsValue({
      "idOutroCargo": undefined,
      "matriculaEfpc": undefined,
      "sigla": undefined,
      "idTipoFuncao": undefined,
      "nmTipoFuncao": undefined,
      "idAreaConhecimento": undefined,
      "nmArea": undefined,
      "dtInicioAtuacao": undefined,
      "dtFimAtuacao": undefined,
      "razaoSocial": undefined,
      "nuCnpj": undefined,
    });

    setDadosOutroCargo(undefined);
    setDadosAuditoria([]);

    setLoading(false);
    window.scrollTo(0, 0)
  };

  // const validarOutroCargo = () => {
  //   form
  //     .validateFields([
  //       "matriculaEfpc",
  //       "idAreaConhecimento",
  //       "itTipoFuncao",
  //       "dtInicioAtuacao",
  //       "dtFimAtuacao",
  //     ])
  //     .then(() => {
  //       sendForm();
  //     })
  //     .catch((error) => {
  //       errorMessage("Campo obrigatório não preechido");
  //     });
  //   //  }
  // };

  const [ctrlDoc, setCtrlDoc] = useState<ICtrlDoc[]>([]);
  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,entidade,manter,conselheiro-deliberativo,conselheiro-fiscal,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDoc(data.content);
  };

  // Add/remove event listener based on `isDirty`
  useEffect(() => {
    const handler = handlerRef.current!;
    if (isDirty) {
      window.addEventListener('beforeunload', handler);
    } else {
      window.removeEventListener('beforeunload', handler);
    }

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [isDirty]);

  return (
    <>
      {/* <Prompt
        when={manter === 3}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}
      <Watermark display={manter === 9 ? "inline" : "none"} />

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title={
            (() => {
              switch (manter) {
                case 2:
                  return "Detalhar Outro Cargo"
                case 3:
                  return "Alterar Outro Cargo"
                case 9:
                  return "Histórico Outro Cargo"
                default:
                  return null
              }
            })()}
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />


        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            // initialValues={{ remember: false }}
            onFinish={sendForm}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item label="CPF" name="nuCpf">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisica">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} style={{ display: manter !== 9 ? 'inline' : 'none' }}  >
                  <Form.Item style={{ alignItems: 'center' }}
                    label={mostrarDetalhesPessoaFisica ? "Ocultar detalhe Cadastro de Pessoa Física" : "Detalhar Cadastro de Pessoa Física"}
                  >
                    <Button
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>

              </Row>

              <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }} >
                <>
                  <PessoaFisicaDadosPessoaisComplementares
                    form={form}
                    idPessoaFisica={idPessoaFisica}
                    mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                  />
                </>
              </Row>


            </Card>

            <Card title={"Dados do Cargo/Função"}>
              <>
                <OutroCargoPerfil
                  form={form}
                  entidades={entidades}
                  tiposFuncoes={tiposFuncoes}
                  areasConhecimento={areasConhecimento}
                  manter={manter}
                  dadosOutroCargo={dadosOutroCargo}
                />
              </>
            </Card>

            {manter === 2 ?
              <Tabs>
                <Tabs.TabPane tab="Histórico" key="item-9" style={{ display: manter !== 2 ? 'none' : 'inline' }}>
                  <>
                    <Auditoria
                      dadosAuditoria={dadosAuditoria}
                      setRegistroHistorico={setRegistroHistorico}
                    />
                  </>
                </Tabs.TabPane>

              </Tabs> : ""}


            <div style={{ display: manter === 9 ? 'inline' : 'none' }}>
              <InfoHistorico form={form} registroHistorico={registroHistorico} />
            </div>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              desabilitaBtnEditar={desabilitaBtnEditar}
              permitirExcluir={hasPermissao([Papel.DILIC_MASTER])}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
              setLoading={setLoading}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Manter;